import React from 'react';
import searchIcon from 'src/assets/images/common/search-black.svg';
import deleteIcon from 'src/assets/images/common/delete.svg';

const Search = React.forwardRef(({ typeInput = null, callBack, searchValue, classes, imgclass, widthClass, placeholders, width, onFocus, onClick, isDeleteShow = false, isDeleteAction = () => {} ,hideIcon = false, disabled = false }, ref) => {
  return (
    <React.Fragment>
      <div style={{width: width}} className={`position-relative ${widthClass}`}>
        <input
         autoComplete='off'
          type={typeInput || "search"}
          ref={ref}
          className={`border rounded-8 f-14 py-2 p-l-35 h-40 pr-2 w-100 bg-white ${classes}`}
          placeholder={placeholders ? placeholders : "Search"}
          value={searchValue}
          onChange={callBack}
          onPaste={callBack}
          onFocus={onFocus}
          onClick={onClick}
          disabled={disabled}
        />
        {!hideIcon && !isDeleteShow && <img src={searchIcon} alt="search" className={`position-absolute wid-15 search-box ${imgclass}`} />}
        {isDeleteShow && (
          <img src={deleteIcon} alt="delete" className={`position-absolute wid-15 search-box ${imgclass}`} onClick={isDeleteAction} />
        )}
      </div>
    </React.Fragment>
  );
});

export default Search;

